import { render, staticRenderFns } from "./ReadonlyModal.vue?vue&type=template&id=0fab68c4"
import script from "./ReadonlyModal.vue?vue&type=script&lang=ts"
export * from "./ReadonlyModal.vue?vue&type=script&lang=ts"
import style0 from "./ReadonlyModal.vue?vue&type=style&index=0&id=0fab68c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports